import { render, staticRenderFns } from "./optionsdialog.vue?vue&type=template&id=5e67f8c6&scoped=true"
import script from "./optionsdialog.vue?vue&type=script&lang=js"
export * from "./optionsdialog.vue?vue&type=script&lang=js"
import style0 from "./optionsdialog.vue?vue&type=style&index=0&id=5e67f8c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e67f8c6",
  null
  
)

export default component.exports